import Icon from 'ui/components/Icon'
import { Root, Summary, Details } from './styled'

const BaseExpandableCard = ({
  id,
  expanded,
  onToggle,
  header,
  children,
  iconPosition = 'right',
  iconGap = 24,
  variant = 'default',
}) => {
  const handleChange = (_, next) => {
    onToggle?.(id, next)
  }

  return (
    <Root expanded={expanded} onChange={handleChange} disableGutters>
      <Summary
        $iconPosition={iconPosition}
        $iconGap={iconGap}
        $variant={variant}
        expandIcon={<Icon name="chevron" />}
      >
        {header}
      </Summary>
      <Details $variant={variant}>{children}</Details>
    </Root>
  )
}

export default BaseExpandableCard
